import { render, staticRenderFns } from "./WxVoicePlayer.vue?vue&type=template&id=b62a054e&scoped=true"
import script from "./WxVoicePlayer.vue?vue&type=script&lang=js"
export * from "./WxVoicePlayer.vue?vue&type=script&lang=js"
import style0 from "./WxVoicePlayer.vue?vue&type=style&index=0&id=b62a054e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62a054e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b62a054e')) {
      api.createRecord('b62a054e', component.options)
    } else {
      api.reload('b62a054e', component.options)
    }
    module.hot.accept("./WxVoicePlayer.vue?vue&type=template&id=b62a054e&scoped=true", function () {
      api.rerender('b62a054e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wechat/WxVoicePlayer.vue"
export default component.exports